import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-subscription-modal',
  templateUrl: './subscription-modal.component.html',
  styleUrls: ['./subscription-modal.component.scss'],
})
export class SubscriptionModalComponent implements OnInit {
  @Input() selectedUser: any;
  constructor(private modal: NzModalRef) {}

  ngOnInit(): void {}
  closeModal(): void {
    this.modal.destroy(); // closes and destroys the modal
  }
}
